import { render, staticRenderFns } from "./template1.vue?vue&type=template&id=71d8c815&scoped=true&"
import script from "./template1.vue?vue&type=script&lang=js&"
export * from "./template1.vue?vue&type=script&lang=js&"
import style0 from "./template1.vue?vue&type=style&index=0&id=71d8c815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8c815",
  null
  
)

export default component.exports